/**
 * Estadísticas de filtrado - V05.3
 * PTEL - Sistema de Normalización de Coordenadas
 */

import React, { memo } from 'react';
import { Button } from '../../ui/button';
import { RotateCcw } from 'lucide-react';
import type { FilterStats as FilterStatsType } from './types';

export interface FilterStatsProps {
  stats: FilterStatsType;
  onReset: () => void;
  showReset?: boolean;
}

export const FilterStats = memo<FilterStatsProps>(function FilterStats({
  stats,
  onReset,
  showReset = true,
}) {
  const percentage = stats.total > 0 
    ? Math.round((stats.filtered / stats.total) * 100) 
    : 0;

  const isFiltered = stats.filtered < stats.total;

  return (
    <div className="ptel-filter-stats space-y-3">
      {/* Contador */}
      <div className="flex items-center justify-between">
        <span className="text-sm text-stone-400">
          Mostrando{' '}
          <span className="font-mono text-lime-400">{stats.filtered}</span>
          {' '}de{' '}
          <span className="font-mono text-stone-300">{stats.total}</span>
        </span>
        <span className="text-xs text-stone-500 font-mono">
          {percentage}%
        </span>
      </div>

      {/* Barra de progreso */}
      <div className="h-1.5 bg-stone-800 rounded-full overflow-hidden">
        <div
          className="h-full bg-lime-500 transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Botón reset */}
      {showReset && isFiltered && (
        <Button
          variant="outline"
          size="sm"
          onClick={onReset}
          className="w-full text-stone-400 border-stone-700 hover:bg-stone-800"
        >
          <RotateCcw className="h-4 w-4 mr-2" />
          Resetear filtros
        </Button>
      )}
    </div>
  );
});

export default FilterStats;
